import React from "react";
import { Box, TextField, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import DocumentItem from "../../../Components/Masters/DocumentItem";
import { getMonthName } from "../../../utils/getMonthName";
import { truncateNumber } from "../../../utils/common";

function ViewLogisticsVendorMaster(props) {
  const handleDownload = (url) => {
    const downloadUrl = url.replace("/upload/", "/upload/fl_attachment/"); // Force download as an attachment
    const link = document.createElement("a");
    link.href = downloadUrl;
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => props.setView(false)}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          Consumption by Facility Details
        </Typography>
        <Box display="flex" gap={5.5} style={{ marginBottom: "0.75rem" }}>
          <Box style={{ width: "42%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Date
            </Typography>

            <p>
              {new Date(props.selectedData?.createdAt).toLocaleDateString(
                "en-GB",
                { day: "2-digit", month: "2-digit", year: "numeric" }
              ) ?? ""}
              {/* {new Date(props.selectedData?.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' }) ?? ""} */}
            </p>
          </Box>
          <Box style={{ width: "42%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Consumption Month
            </Typography>
            <Typography>
              {getMonthName(props.selectedData?.consumptionPeriod?.month) +
                " " +
                props.selectedData?.consumptionPeriod?.year}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" gap={5.5}>
          <Box style={{ width: "42%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Previous Reading(KWH)
            </Typography>
            <p>
              {" "}
              {truncateNumber(props.selectedData?.previousMeterReading) ?? ""}
            </p>
          </Box>
          <Box style={{ width: "42%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Current Reading(KWH)
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
              {truncateNumber(props.selectedData?.currentMeterReading) ?? ""}
            </p>
          </Box>
        </Box>
        <Box display="flex" gap={5.5}>
          <Box style={{ width: "42%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Units Consumed (KWH)
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {props.selectedData?.unitOfElectricityConsumption === ""
                ? "-"
                : truncateNumber(
                    props.selectedData?.unitOfElectricityConsumption
                  )}
            </p>
          </Box>
          <Box style={{ width: "42%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Vendor Name
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {props.selectedData?.vendor?.VendorLegalFullName ?? ""}
            </p>
          </Box>
        </Box>
        <Box display="flex" gap={5.5} sx={{ mb: 2 }}>
          <Box style={{ width: "42%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Equipment (optional)
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {props.selectedData?.equipment?.length
                ? props.selectedData.equipment
                    .map((item) => item?.equipment)
                    .join(", ")
                : "-"}
            </p>
          </Box>
          <Box style={{ width: "42%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Multiplication Factor
            </Typography>
            <Box>
              <Typography>
                {props.selectedData?.multiplicationFactor}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
          Reason For Deviation (optional)
        </Typography>
        <p>
          {props?.selectedData?.reasonForDeviation === ""
            ? "-"
            : props?.selectedData?.reasonForDeviation}
        </p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
          Remark (optional)
        </Typography>
        <p>{props.selectedData?.remarks || "-"}</p>

        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Documents (optional)
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            gap={1}
            sx={{ width: "100%" }}
          >
            {/* Render Images First */}
            {props?.selectedData &&
              props.selectedData?.documents?.length > 0 && (
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {props.selectedData?.documents
                    .filter((url) =>
                      ["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                    )
                    .map((url, index) => (
                      <DocumentItem key={`image-${index}`} url={url} />
                    ))}
                </Box>
              )}

            {/* Render Other Documents */}
            {props.selectedData && props.selectedData?.documents.length > 0 ? (
              <Box display="flex" flexWrap="wrap" gap={1}>
                {props.selectedData.documents
                  .filter(
                    (url) =>
                      !["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                  )
                  .map((url, index) => (
                    <DocumentItem key={`file-${index}`} url={url} />
                  ))}
              </Box>
            ) : (
              "-"
            )}
          </Box>
        </Box>

        {/* Edit Button */}
        {!props?.companyAdmin && (
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={() =>
              props.selectedData?._id !== null &&
              props.handleEdit(props.selectedData)
            }
          >
            Edit
          </Button>
        )}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.view}
        onClose={() => props.setView(false)}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default ViewLogisticsVendorMaster;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
